import { OptionInitialValue } from '@app/main/api';

export const convertOptionToSourceItems = (option?: OptionInitialValue | null) => {
  return option ? [{ label: option.name, value: option.id }] : undefined;
};
